import { JSX } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Contact from './views/Contact';
import Footer from './views/Footer';
import Home from './views/Home';
import Login from './views/Login';
import Navbar from './views/Navbar';
import NotFoundPage from './views/NotFoundPage';
import Pricing from './views/Pricing';
import Profile from './views/Profile';
import Services from './views/Services';

import './App.css';

function App(): JSX.Element {
  const isLoggedIn = false;

  return (
    <Router basename='/'>
      <div className='App'>
        <Navbar isLoggedIn={isLoggedIn} />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/services' element={<Services />} />
          <Route path='/pricing' element={<Pricing />} />
          <Route path='/contact' element={<Contact />} />
          <Route
            path='/profile'
            element={<Profile isLoggedIn={isLoggedIn} />}
          />
          <Route path='/login' element={<Login />} />

          <Route path='*' element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
